
import ApiService from '../base/api_service';

export const getProcurementUpdate = async (accessToken, params) => {
    try {
        const response = await ApiService.get('/procurement-updates', {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const showProcurementUpdate = async (accessToken, id) => {
    try {
        const response = await ApiService.get(`/procurement-update/show/${id}`, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const postProcurementUpdate = async (accessToken, data) => {
    try {
        const response = await ApiService.post('/procurement-update/create', data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const updateProcurementUpdate = async (accessToken, id, data) => {
    try {
        const response = await ApiService.post(`/procurement-update/update/${id}`, data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}